import { t } from "@/lib/i18n";

export default function PageHeader({ eyebrow, title, subtitle, children, testid }) {
  return (
    <section className="relative overflow-hidden" data-testid={testid}>
      <div className="absolute inset-0 jali-bg opacity-50 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-16 pb-10">
        <div className="text-xs font-bold tracking-[0.2em] uppercase text-[var(--leaf)] fade-up">{t(eyebrow)}</div>
        <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.04] max-w-4xl fade-up" style={{ animationDelay: "80ms" }}>{t(title)}</h1>
        {subtitle && <p className="mt-5 text-base sm:text-lg text-[var(--ink-soft)] max-w-2xl leading-relaxed fade-up" style={{ animationDelay: "160ms" }}>{t(subtitle)}</p>}
        {children}
      </div>
    </section>
  );
}
